export default __webpack_public_path__ + "static/media/ESSP32ROSE01_1920x1080.b622a685.jpg";